export default [
  'mdiInformation',
  'mdiInformationOutline',
  'mdiInformationVariant',
  'mdiFolderInformation',
  'mdiFolderInformationOutline',
  'mdiAlert',
  'mdiAlertOutline',
  'mdiAlertBox',
  'mdiAlertBoxOutline',
  'mdiAlertCircle',
  'mdiAlertCircleOutline',
  'mdiAlertDecagram',
  'mdiAlertDecagramOutline',
  'mdiAlertOctagon',
  'mdiAlertOctagonOutline',
  'mdiAlertOctagram',
  'mdiAlertOctagramOutline',
  'mdiShieldAlert',
  'mdiShieldAlertOutline',
  'mdiFolderAlert',
  'mdiFolderAlertOutline',
  'mdiFileAlert',
  'mdiFileAlertOutline',
  'mdiCheck',
  'mdiCheckBold',
  'mdiCheckCircle',
  'mdiCheckCircleOutline',
  'mdiCheckDecagram',
  'mdiCheckDecagramOutline',
  'mdiShieldCheck',
  'mdiShieldCheckOutline',
  'mdiCancel',
  'mdiHelp',
  'mdiHelpBox',
  'mdiHelpCircle',
  'mdiHelpCircleOutline',
  'mdiProgressQuestion',
];
